function rgb2hex(r: number, g: number, b: number) {
  r = Math.round(r);
  g = Math.round(g);
  b = Math.round(b);
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

function hex2rgb(code: string) {
  // var code = "#8f5c44";
  var red = parseInt(code.substring(1, 3), 16);
  var green = parseInt(code.substring(3, 5), 16);
  var blue = parseInt(code.substring(5, 7), 16);
  return { red, green, blue };
}

function rgb2hsv(r: number, g: number, b: number) {
  let v = Math.max(r, g, b),
    c = v - Math.min(r, g, b);
  let h =
    c && (v === r ? (g - b) / c : v === g ? 2 + (b - r) / c : 4 + (r - g) / c);

  const hue = 60 * (h < 0 ? h + 6 : h);
  const saturation = v && c / v;
  const value = v;

  return { hue, saturation, value };
}

function hsv2rgb(h: number, s: number, v: number) {
  let f = (n: number, k = (n + h / 60) % 6) =>
    v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
  var red = f(5);
  var green = f(3);
  var blue = f(1);
  return { red, green, blue };
}

function add_color_value(hex: string, dx: number) {
  const org = hex2rgb(hex);
  let hsv = rgb2hsv(org.red, org.green, org.blue);
  hsv.value = Math.max(0, Math.min(hsv.value + dx, 255));
  const fixed = hsv2rgb(hsv.hue, hsv.saturation, hsv.value);
  return rgb2hex(fixed.red, fixed.green, fixed.blue);
}

export function to_dark(hex: string) {
  const t = add_color_value(hex, -30);
  return t;
}

export function to_light(hex: string) {
  return add_color_value(hex, +50);
}
